import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogService } from '../../utility/dialog/edit-dialog-service';
import { HttpService } from '../../utility/http-service';
import { LoginService } from '../../../services/login-service';
import { Router } from '@angular/router';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';
import { DialogService } from '../../utility/dialog/dialog-service';
import { ModalType } from '../../utility/dialog-template/dialog-template.component';
import { ClientOnboardingResult } from '../../../services/ClientOrganizationsService';
import { ClientOrganizationDialogComponent, ClientOrganizationDialogData } from './client-organization-dialog/client-organization-dialog.component';
@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrl: './client.component.css',
  standalone: false
})
export class ClientComponent implements OnInit {


  @ViewChild('clientsGrid') clientsGrid?: WcGridComponent;

  constructor(public dialogService: EditDialogService, private http: HttpService, public loginService: LoginService, public router: Router,
              private dialog: MatDialog, private messages: DialogService) {

  }

  ngOnInit(): void {

  }

  onGridMenu(e: { id: string; row: Record<string, any> }) {
    switch (e.id) {
      case 'edit':
        if (e.row) {
          this.onClientRowSelected(e.row)
        }
        break;
      case 'link':
        if (e.row) {
          this.openLinkOrganization(e.row);
        }
        break;
    }
  }

  public context: Record<string, any> = {};
  gridMenu = [
    { id: 'edit', label: 'View/Edit' },
    { id: 'link', label: 'Link organization' }
  ];

  openAddClient(): void {
    this.openOrganizationDialog({ mode: 'add' });
  }

  openLinkOrganization(row: Record<string, any>): void {
    if (row['OrganizationId']) {
      this.messages.openModal('Well Chron', `'${row['DisplayName']}' is already linked to an Enverus organization.`, ModalType.INFO);
      return;
    }
    this.openOrganizationDialog({ mode: 'link', clientId: row['Id'], clientName: row['DisplayName'] });
  }

  private openOrganizationDialog(data: ClientOrganizationDialogData): void {
    const ref = this.dialog.open<ClientOrganizationDialogComponent, ClientOrganizationDialogData, ClientOnboardingResult | undefined>(
      ClientOrganizationDialogComponent, {
        data,
        width: '720px',
        maxWidth: '95vw',
      });

    ref.afterClosed().subscribe(result => {
      if (!result) return;
      this.clientsGrid?.reload(1);
      if (result.warning) this.messages.openModal('Well Chron', result.warning, ModalType.WARN);
    });
  }

  onClientRowSelected(client: any): void {
    const id = client?.Id ?? client?.ClientId;
    if (client && id) {
      const tree = this.router.createUrlTree([`/client/${id}`]);
      const url = this.router.serializeUrl(tree);
      window.open(url, '_blank');
    }
  }
}



export declare interface GenericSelectModel {
    current: GenericSelectItem[];
    available: GenericSelectItem[];
}

export declare interface GenericSelectItem {
    value: string;
    caption: string;
    found: boolean;
}

export declare interface RegionSelectModel {
  current: RegionSelectItem[];
  available: RegionSelectItem[];
}

export declare interface RegionSelectItem {
  regionName: string;
  caption: string;
}
